<template>
    <div :class="containerClass">
        <v-toolbar :class="customClass" color="primary" dark @click="onClickToggle">
            <slot name="header" />
            <v-spacer />
            <v-toolbar-items>
                <slot name="icons" />
                <AQIcon v-if="props.collapsible" :name="action" style="height: 100%" />
            </v-toolbar-items>
        </v-toolbar>

        <v-card
            v-if="showChildren || !props.collapsible"
            :class="`border ${noPadding ? 'noBoxShadow' : 'pa-4'}`"
        >
            <slot name="content" />
        </v-card>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch, toRefs, computed } from 'vue';

    const props = defineProps({
        openedBox: {
            type: Object,
            default: () => ({}),
        },
        openingIcon: {
            type: String,
            default: 'mdi-pencil-outline',
        },
        closingIcon: {
            type: String,
            default: 'mdi-close',
        },
        collapsible: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        containerClass: {
            type: String,
            default: '',
        },
        collapseExpandAll: {
            type: String,
            default: '',
        },
    });

    const emit = defineEmits<{
        (e: 'onBoxToggle', value: { openedBox: object; boxIsOpen: boolean }): void;
    }>();

    const { collapseExpandAll } = toRefs(props);

    const showChildren = ref(false);

    const action = computed(() => {
        return showChildren.value ? props.closingIcon : props.openingIcon;
    });

    watch(collapseExpandAll, (val) => {
        if (val === 'expandAll') showChildren.value = true;
        if (val === 'collapseAll') showChildren.value = false;
    });

    const onClickToggle = () => {
        if (props.collapsible) {
            showChildren.value = !showChildren.value;
            emit('onBoxToggle', { openedBox: props.openedBox, boxIsOpen: showChildren.value });
        }
    };
</script>
